import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/services/network';
import { downloadBlobAsFile } from 'src/utils/DownloadFile';

export const songsLibraryOverview = createAsyncThunk(
  'SONGS_LIBRARY_OVERVIEW',
  async () => {
    return axios
      .get('/subscriptions/mtr/songs/library/overview')
      .then((response) => {
        return response.data;
      });
  }
);

export const songsAirPlayReport = createAsyncThunk(
  'SONGS_AIRPLAY_REPORT',
  async (songIds: string[]) => {
    return axios
      .post(
        '/reporting/songs/airplay-report',
        { song_ids: songIds },
        { responseType: 'blob' }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        downloadBlobAsFile(blob, response.headers, 'airplay_report.zip');
      });
  }
);
